import React, { useState, useEffect } from 'react';
import './Events.css'; // Add styles for the Events page
import { db } from '../../firebase'; // Import Firestore instance
import { collection, addDoc, getDocs, setDoc, deleteDoc, doc, updateDoc, query, where } from 'firebase/firestore';
import { getAuth } from 'firebase/auth'; // Import Firebase Auth
import { FaBarcode, FaCalendarAlt, FaTicketAlt, FaMoneyBillAlt } from 'react-icons/fa'; // Import icons

function Events() {
  const [events, setEvents] = useState([]); // Store all events
  const [isCreatingEvent, setIsCreatingEvent] = useState(false); // Toggle between states
  const [formData, setFormData] = useState({
    eventName: '',
    eventLocation: '',
  }); // Removed games field
  const [serialNumberInputs, setSerialNumberInputs] = useState({}); // Track serial number inputs for each game
  const [gameNameInputs, setGameNameInputs] = useState({}); // Track input for "Game Name" during editing
  const [winningTicketInputs, setWinningTicketInputs] = useState({}); // Track winning ticket inputs for each game
  const [newGameInput, setNewGameInput] = useState(''); // Track input for adding a new game
  const [editingGameIndex, setEditingGameIndex] = useState(null); // Track which game is being edited
  const [isGameModalOpen, setIsGameModalOpen] = useState(false); // State to toggle game modal visibility
const [gameToDelete, setGameToDelete] = useState(null); // Track the game index to delete
const [eventIdForGame, setEventIdForGame] = useState(null); // Track the event ID for the game to delete
const [isEventModalOpen, setIsEventModalOpen] = useState(false); // State to toggle event modal visibility
const [eventToDelete, setEventToDelete] = useState(null); // Track the event ID to delete
const [successMessage, setSuccessMessage] = useState(''); // State for success message
const [prizeInputs, setPrizeInputs] = useState({}); // Track input for "Prize" during editing
const [newPrizeInput, setNewPrizeInput] = useState(''); // Track input for "Prize" during game creation
const [newSerialNumberInput, setNewSerialNumberInput] = useState(''); // Track input for serial number during game creation
const [newGameTypeInput, setNewGameTypeInput] = useState(''); // Track input for game type during game creation
const [gameTypeInputs, setGameTypeInputs] = useState({}); // Track input for "Game Type" during editing
const [hiddenEvents, setHiddenEvents] = useState({}); // Track hidden state for each event
const [searchQuery, setSearchQuery] = useState(''); // Track the search query
const [searchResults, setSearchResults] = useState([]); // Store filtered search results

  // Fetch events from Firestore on component mount
  useEffect(() => {
    const fetchEvents = async () => {
      const auth = getAuth();
      const currentUser = auth.currentUser;
  
      if (!currentUser) {
        console.error('No user is logged in.');
        return;
      }
  
      try {
        // Query events created by the logged-in user
        const eventsQuery = query(
          collection(db, 'events'),
          where('createdBy', '==', currentUser.email) // Filter by the logged-in user's email
        );
  
        const querySnapshot = await getDocs(eventsQuery);
        const eventsData = querySnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
  
        setEvents(eventsData); // Update state with filtered events
      } catch (error) {
        console.error('Error fetching events:', error);
      }
    };
  
    fetchEvents();
  }, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleCreateEvent = async (e) => {
    e.preventDefault();
    const auth = getAuth();
    const currentUser = auth.currentUser;

    if (!currentUser) {
      alert('You must be logged in to create an event.');
      return;
    }

    const newEvent = {
      ...formData,
      games: [], // Initialize games as an empty array
      createdBy: currentUser.email, // Add the user's email to the event
    };

    try {
      // Add the event to Firestore and get the document reference
      const docRef = await addDoc(collection(db, 'events'), newEvent);

      // Add the event ID to the local state
      setEvents([...events, { id: docRef.id, ...newEvent }]);

      // Reset the form
      setFormData({ eventName: '', eventLocation: '' });
      alert('Event created successfully!');
      setIsCreatingEvent(false); // Return to the event list view
    } catch (error) {
      console.error('Error creating event:', error);
      alert('Failed to create the event.');
    }
  };

  

  const handleAddGame = async (eventId) => {
    const auth = getAuth();
    const currentUser = auth.currentUser;
  
    if (!currentUser) {
      alert('You must be logged in to add a game.');
      return;
    }
  
    if (!newGameInput.trim()) {
      alert('Please enter a game name.');
      return;
    }
  
    const updatedEvents = [...events];
    const event = updatedEvents.find((e) => e.id === eventId && e.createdBy === currentUser.email);
  
    if (!event) {
      alert('You cannot add a game to an event that does not belong to you.');
      return;
    }
  
    // Add the new game with Prize, Serial Number, and Game Type to the local state
    event.games.push({
      name: newGameInput,
      prize: newPrizeInput,
      winningTickets: [],
      serialNumber: newSerialNumberInput,
      gameType: newGameTypeInput,
    });
  
    try {
      // Update Firestore
      const eventRef = doc(db, 'events', eventId);
      await updateDoc(eventRef, { games: event.games });
  
      // Update local state
      setEvents(updatedEvents);
      setNewGameInput(''); // Clear the game name input field
      setNewPrizeInput(''); // Clear the "Prize" input field
      setNewSerialNumberInput(''); // Clear the serial number input field
      setNewGameTypeInput(''); // Clear the game type input field
      setSuccessMessage('Game added successfully!'); // Set success message
  
      // Clear the success message after 3 seconds
      setTimeout(() => setSuccessMessage(''), 3000);
    } catch (error) {
      console.error('Error adding game:', error);
      alert('Failed to add the game.');
    }
  };

  const handleDeleteGame = async (eventId, gameIndex) => {
    const updatedEvents = [...events];
    const event = updatedEvents.find((e) => e.id === eventId);
  
    // Remove the specific game from the local state
    event.games.splice(gameIndex, 1);
  
    try {
      // Update Firestore
      const eventRef = doc(db, 'events', eventId);
      await updateDoc(eventRef, { games: event.games });
  
      setEvents(updatedEvents); // Update local state
      alert('Game deleted successfully!');
    } catch (error) {
      console.error('Error deleting game:', error);
      alert('Failed to delete the game.');
    }
  };

  const handleDeleteEvent = async (eventId) => {
    try {
      await deleteDoc(doc(db, 'events', eventId));
      setEvents(events.filter((event) => event.id !== eventId));
      alert('Event deleted successfully!');
    } catch (error) {
      console.error('Error deleting event:', error);
      alert('Failed to delete the event.');
    }
  };

  const handleArchiveEvent = async (eventOrId) => {
    try {
      // Check if the input is an ID or a full event object
      const event = typeof eventOrId === 'string'
        ? events.find((e) => e.id === eventOrId) // Find the event by ID
        : eventOrId;
  
      console.log('Event object:', event);
  
      // Validate the event object
      if (!event || !event.id) {
        console.error('Event ID is missing:', event);
        throw new Error('Invalid event object');
      }
  
      console.log('Archiving event with ID:', event.id);
  
      // Move the event to the "archivedEvents" collection with the same ID
      const archivedEventRef = doc(db, 'archivedEvents', event.id);
      await setDoc(archivedEventRef, {
        eventName: event.eventName,
        eventLocation: event.eventLocation,
        createdBy: event.createdBy,
        games: event.games || [], // Include games if they exist
      });
  
      // Remove the event from the "events" collection
      const eventRef = doc(db, 'events', event.id);
      await deleteDoc(eventRef);
  
      // Update local state to remove the event from events
      setEvents((prevEvents) => prevEvents.filter((e) => e.id !== event.id));
  
      alert('Event archived successfully!');
    } catch (error) {
      console.error('Error archiving event:', error);
      alert('Failed to archive the event.');
    }
  };

  

  const handleAnnounceWinner = async (eventId, game) => {
    if (!game.name || !game.serialNumber || !game.winningTicket) {
      alert('Game details are incomplete. Please ensure the game has a name, serial number, and winning ticket.');
      return;
    }
  
    const announcement = `Winner Announcement: The Game "${game.name}" with the Serial Number "${game.serialNumber}" has the Winning Ticket(s) "${game.winningTicket}".`;
  
    try {
      const eventRef = doc(db, 'events', eventId);
      await updateDoc(eventRef, {
        announcement: announcement,
        announcementTimestamp: Date.now(),
      });
  
      alert('Winner announcement made successfully!');
    } catch (error) {
      console.error('Error making winner announcement:', error);
      alert('Failed to make the winner announcement.');
    }
  };

  const handleSaveEditedGame = async (eventId, gameIndex) => {
    const auth = getAuth();
    const currentUser = auth.currentUser;
  
    if (!currentUser) {
      alert('You must be logged in to edit a game.');
      return;
    }
  
    const updatedEvents = [...events];
    const event = updatedEvents.find((e) => e.id === eventId && e.createdBy === currentUser.email);
  
    if (!event) {
      alert('You cannot edit a game in an event that does not belong to you.');
      return;
    }
  
    // Get the current game
    const currentGame = event.games[gameIndex];
  
    // Update the game with the new name and other fields
    const updatedGame = {
      ...currentGame,
      name: gameNameInputs[gameIndex] || currentGame.name, // Update the game name
      serialNumber: serialNumberInputs[gameIndex] || currentGame.serialNumber, // Retain previous value if no input
      winningTicket: winningTicketInputs[gameIndex] || currentGame.winningTicket || 'N/A', // Default to "N/A" if no input
      prize: prizeInputs[gameIndex] || currentGame.prize, // Retain previous value if no input
      gameType: gameTypeInputs[gameIndex] || currentGame.gameType || 'N/A', // Default to "N/A" if no input
    };
  
    // Update the game in the local state
    event.games[gameIndex] = updatedGame;
  
    try {
      // Update Firestore
      const eventRef = doc(db, 'events', eventId);
      await updateDoc(eventRef, { games: event.games });
  
      // Update local state
      setEvents(updatedEvents);
      setEditingGameIndex(null); // Exit editing mode
      setGameNameInputs({ ...gameNameInputs, [gameIndex]: '' }); // Clear the input field
      setSerialNumberInputs({ ...serialNumberInputs, [gameIndex]: '' }); // Clear the input field
      setWinningTicketInputs({ ...winningTicketInputs, [gameIndex]: '' }); // Clear the input field
      setPrizeInputs({ ...prizeInputs, [gameIndex]: '' }); // Clear the input field
      setGameTypeInputs({ ...gameTypeInputs, [gameIndex]: '' }); // Clear the input field
      alert('Game updated successfully!');
    } catch (error) {
      console.error('Error saving edited game:', error);
      alert('Failed to save the edited game.');
    }
  };

  const handleEditGame = (gameIndex) => {
    setEditingGameIndex(editingGameIndex === gameIndex ? null : gameIndex); // Toggle edit mode
  };

  const handleDeleteGameClick = (eventId, gameIndex) => {
    setEventIdForGame(eventId); // Set the event ID
    setGameToDelete(gameIndex); // Set the game index to delete
    setIsGameModalOpen(true); // Open the modal
  };
  
  const confirmDeleteGame = async () => {
    try {
      await handleDeleteGame(eventIdForGame, gameToDelete); // Call the delete function
      setIsGameModalOpen(false); // Close the modal
      setGameToDelete(null); // Clear the game index
      setEventIdForGame(null); // Clear the event ID
    } catch (error) {
      console.error('Error deleting game:', error);
    }
  };
  
  const closeGameModal = () => {
    setIsGameModalOpen(false); // Close the modal
    setGameToDelete(null); // Clear the game index
    setEventIdForGame(null); // Clear the event ID
  };

  const confirmDeleteEvent = async () => {
    try {
      await handleDeleteEvent(eventToDelete); // Call the delete function
      setIsEventModalOpen(false); // Close the modal
      setEventToDelete(null); // Clear the event ID
    } catch (error) {
      console.error('Error deleting event:', error);
    }
  };

  const handleHideEvent = (eventId) => {
    setHiddenEvents({ ...hiddenEvents, [eventId]: true }); // Mark the event as hidden
  };
  
  const handleShowEvent = (eventId) => {
    setHiddenEvents({ ...hiddenEvents, [eventId]: false }); // Mark the event as visible
  };
  
  const closeEventModal = () => {
    setIsEventModalOpen(false); // Close the modal
    setEventToDelete(null); // Clear the event ID
  };

  const handleSearch = () => {
    if (!searchQuery.trim()) {
      setSearchResults([]); // Clear results if the query is empty
      return;
    }

    const query = searchQuery.trim().toLowerCase();
  
    const results = [];
  
    // Loop through events and their games
    events.forEach((event) => {
      if (!Array.isArray(event.games)) {
        return;
      }

      event.games.forEach((game) => {
        const gameName = String(game?.name || '');
        const serialNumber = String(game?.serialNumber || '');
        const winningTicket = String(game?.winningTicket || '');

        // Check if the game name matches the search query
        if (gameName.toLowerCase().includes(query)) {
          results.push({
            type: 'Game',
            value: gameName,
            eventName: event.eventName,
            details: game,
          });
        }
  
        // Check if the serial number matches the search query
        if (serialNumber.toLowerCase().includes(query)) {
          results.push({
            type: 'Serial Number',
            value: serialNumber,
            eventName: event.eventName,
            details: game,
          });
        }
  
        // Check if the winning ticket matches the search query
        if (winningTicket.toLowerCase().includes(query)) {
          results.push({
            type: 'Winning Ticket',
            value: winningTicket,
            eventName: event.eventName,
            details: game,
          });
        }
      });
    });
  
    setSearchResults(results); // Update the search results
  };

  const handleClearSearch = () => {
    setSearchQuery(''); // Reset the search query
    setSearchResults([]); // Clear the search results
  };

  return (
    <div className="events-container">
      <div className="search-section">
  <input
    type="text"
    placeholder="Search games, serial numbers, or winning tickets"
    value={searchQuery}
    onChange={(e) => setSearchQuery(e.target.value)}
    className="search-input"
  />
  <button onClick={handleSearch} className="search-button">
    Search
  </button>
  <button onClick={handleClearSearch} className="clear-search-button">
    Clear Search
  </button>
</div>
<div className="search-results">
  {searchResults.length > 0 ? (
    <ul>
      {searchResults.map((result, index) => (
        <li key={index} className="search-result-item">
          <strong>{result.type}:</strong> {result.value} (Event: {result.eventName})
          <div className="game-details">
            <p>
              <FaBarcode style={{ marginRight: '8px', color: 'gold' }} />
              Serial Number: {result.details.serialNumber || 'N/A'}
            </p>
            <p>
              <FaTicketAlt style={{ marginRight: '8px', color: 'gold' }} />
              Winning Ticket: {result.details.winningTicket || 'N/A'}
            </p>
            <p>
              <FaMoneyBillAlt style={{ marginRight: '8px', color: 'gold' }} />
              Prize: {result.details.prize || 'N/A'}
            </p>
          </div>
        </li>
      ))}
    </ul>
  ) : (
    <p>No results found.</p>
  )}
</div>
    {successMessage && (
      <div className="success-message">
        {successMessage}
      </div>
    )}
    {!isCreatingEvent ? (
      <div>
        <h1 className="jew">
          <FaCalendarAlt style={{ marginRight: '12px', color: 'gold' }} /> Events
        </h1>
        <h1> Add games to your event here </h1>
          <ul className="event-list">
            {events.map((event, index) => (
              <li key={event.id}>
                <div className="event-header">
                  <strong>{event.eventName}</strong> (ID: {event.id}) - {event.eventLocation}
                </div>
                <button
        onClick={() =>
          hiddenEvents[event.id] ? handleShowEvent(event.id) : handleHideEvent(event.id)
        }
        className="toggle-event-button"
      >
        {hiddenEvents[event.id] ? 'Show Event' : 'Hide Event'}
      </button>
      <button
  onClick={() => handleArchiveEvent(event.id)}
  className="archive-event-button"
>
  Archive Event
</button>
      {!hiddenEvents[event.id] && (
                <div className="event-summary">
                  <h4>
                    <FaTicketAlt style={{ marginRight: '8px', color: 'gold' }} /> Games
                  </h4>
                  <ul>
  {event.games.map((game, gameIndex) => (
    <li key={gameIndex}>
      <strong>{game.name}</strong>
      <p>
        <FaBarcode style={{ marginRight: '8px', color: 'gold' }} />
        Serial Number: {game.serialNumber || 'N/A'}
      </p>
      <p>
        <FaTicketAlt style={{ marginRight: '8px', color: 'gold' }} />
        Winning Ticket(s): {game.winningTicket || 'N/A'}
      </p>
      <p>
        <FaMoneyBillAlt style={{ marginRight: '8px', color: 'gold' }} />
        Prize: {game.prize || 'N/A'}
      </p>
      <p>
        <FaTicketAlt style={{ marginRight: '8px', color: 'gold' }} />
        Game Type: {game.gameType || 'N/A'}
      </p>
      <button
      onClick={() => handleAnnounceWinner(event.id, game)}
      className="announce-winner-button"
    >
      Announce Winner
    </button>
      <button
        onClick={() => handleEditGame(gameIndex)}
        className="edit-game-button"
      >
        Edit Game
      </button>
      <button
        onClick={() => handleDeleteGameClick(event.id, gameIndex)}
        className="delete-game-button"
      >
        Delete Game
      </button>
{isGameModalOpen && (
  <div className="modalareyou">
    <div className="modal-content">
      <p className='areyou'>Are you sure you want to delete this game?</p>
      <div className="modal-buttons">
        <button onClick={confirmDeleteGame} className="confirm-button">
          Yes, Delete
        </button>
        <button onClick={closeGameModal} className="cancel-button">
          Cancel
        </button>
      </div>
    </div>
  </div>
)}
                        {editingGameIndex === gameIndex && (
  <div className="serial-and-ticket-input">
    <input
      type="text"
      placeholder="Enter Game Name"
      value={gameNameInputs[gameIndex] || game.name} // Default to the current game name
      onChange={(e) =>
        setGameNameInputs({
          ...gameNameInputs,
          [gameIndex]: e.target.value,
        })
      }
      className="modern-input"
    />
    <input
      type="text"
      placeholder="Enter Serial Number"
      value={serialNumberInputs[gameIndex] || ''}
      onChange={(e) =>
        setSerialNumberInputs({
          ...serialNumberInputs,
          [gameIndex]: e.target.value,
        })
      }
      className="modern-input"
    />
    <input
      type="text"
      placeholder="Enter Winning Ticket(s)"
      value={winningTicketInputs[gameIndex] || ''}
      onChange={(e) =>
        setWinningTicketInputs({
          ...winningTicketInputs,
          [gameIndex]: e.target.value,
        })
      }
      className="modern-input"
    />
    <input
      type="text"
      placeholder="Enter Prize"
      value={prizeInputs[gameIndex] || ''}
      onChange={(e) =>
        setPrizeInputs({
          ...prizeInputs,
          [gameIndex]: e.target.value,
        })
      }
      className="modern-input"
    />
    <input
      type="text"
      placeholder="Enter Game Type"
      value={gameTypeInputs[gameIndex] || ''}
      onChange={(e) =>
        setGameTypeInputs({
          ...gameTypeInputs,
          [gameIndex]: e.target.value,
        })
      }
      className="modern-input"
    />
    <button
      onClick={() => handleSaveEditedGame(event.id, gameIndex)}
      className="modern-button"
    >
      Save Changes
    </button>
  </div>
)}
                      </li>
                    ))}
                  </ul>
                  <div className="add-game">
                    <div className="add-game-row">
                      <input
                        type="text"
                        placeholder="Enter New Game Name"
                        value={newGameInput}
                        onChange={(e) => setNewGameInput(e.target.value)}
                        className="modern-input"
                      />
                      <input
                        type="text"
                        placeholder="Enter Prize"
                        value={newPrizeInput}
                        onChange={(e) => setNewPrizeInput(e.target.value)}
                        className="modern-input"
                      />
                    </div>
                    <div className="add-game-row">
                      <input
                        type="text"
                        placeholder="Enter Serial Number"
                        value={newSerialNumberInput}
                        onChange={(e) => setNewSerialNumberInput(e.target.value)}
                        className="modern-input"
                      />
                      <input
                        type="text"
                        placeholder="Enter Game Type"
                        value={newGameTypeInput}
                        onChange={(e) => setNewGameTypeInput(e.target.value)}
                        className="modern-input"
                      />
                    </div>
                    <div className="add-game-row add-game-actions">
                    <button
                      onClick={() => handleAddGame(event.id)}
                      className="add-game-button"
                    >
                      Add Game
                    </button>
                    </div>
                  </div>
{isEventModalOpen && (
  <div className="modal">
    <div className="modal-content">
      <p className='areyou'>Are you sure you want to delete this event?</p>
      <div className="modal-buttons">
        <button onClick={confirmDeleteEvent} className="confirm-button">
          Yes, Delete
        </button>
        <button onClick={closeEventModal} className="cancel-button">
          Cancel
        </button>
      </div>
    </div>
  </div>
)}
                </div>
      )}
              </li>
            ))}
          </ul>
        <button onClick={() => setIsCreatingEvent(true)} className="create-event-button">
          Create New Event
        </button>
        </div>
      ) : (
        <div>
          <h1 className='jude'>Create New Event</h1>
          <form onSubmit={handleCreateEvent} className="event-form">
            <input
              type="text"
              name="eventName"
              placeholder="Event Name"
              value={formData.eventName}
              onChange={handleInputChange}
              required
            />
            <input
              type="text"
              name="eventLocation"
              placeholder="Event Location"
              value={formData.eventLocation}
              onChange={handleInputChange}
              required
            />
            <div className="form-buttons">
              <button type="submit" className="save-event-button">
                Save Event
              </button>
              <button
                type="button"
                onClick={() => setIsCreatingEvent(false)}
                className="back-button"
              >
                Back
              </button>
            </div>
          </form>
        </div>
      )}
    </div>
  );
}

export default Events;